<div class="workSpace">
  <!--nombre y filtro-->
  <div class="w3-container w3-containertemplate" style="height: 7%;">
    <!--Titulo de modulo y subtitulo-->
    <div class="w3-caja-menu padreizquierda w3-quarter">
      <div class="w3-row hijoizquierda centradoVertical">
        <span class="w3-text-deep-orange w3-margin-right-filter w3-tituloPrincipal"> <b> {{
            'menu.'+dataService.moduleSelect | translate }} </b></span>
        <span class="w3-text-deep-orange">&bull;</span>
        <span class="w3-text-orange w3-margin-left-filter w3-subtituloPrincipal"> {{
          'menu.'+dataService.subModuleSelect | translate }} </span>
      </div>
    </div>
  </div>
  <!-- CONTENIDO TABLERO  -->
  <div class="w3-center workSpaceTab">
    <!-- ZONA 1  -->
    <div class="zona1">
      <div class="w3-row w3-titulo-contenidomenuSC">
        <div class="headersZonas">
          <span class="textoZon">{{'cues.resultados.titulo-componente' | translate}}</span>
        </div>
        <div class="hedersIcons">
          <mat-icon class="w3-row w3-rigth w3-button iconoMen" [ngStyle]="{'color':'gray'}" (click)="openModal(3)">
            zoom_out_map
          </mat-icon>
          <mat-icon class="w3-row w3-rigth w3-button iconoMen" [ngClass]="{'color':'grey'}" [matMenuTriggerFor]="menu2">
            more_vert
          </mat-icon>
          <mat-menu #menu2="matMenu">
            <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="exportarExcel()">
              <mat-icon [ngStyle]="{'color':'grey'}">description</mat-icon>
              <span>{{'acciones.exportarExcel' | translate}}</span>
            </button>
            <!-- <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="exportPreguntasRespuestas()">
              <mat-icon [ngStyle]="{'color':'grey'}">description</mat-icon>
              <span>{{'acciones.exportarExcel' | translate}}</span>
            </button> -->
          </mat-menu>
        </div>
      </div>
      <div class="w3-scroll tableZone">
        <table class="w3-table">
          <thead>
            <tr class="w3-table-title">
              <th class="w3-border-right-balance marginIzq stikyColum">
                {{'cues.resultados.titulo-table-1' | translate}}
              </th>
              <th class="w3-border-right-balance marginIzq stikyColum">
                {{'cues.resultados.titulo-table-2' | translate}}
              </th>
              <th class="w3-border-right-balance marginIzq stikyColum">
                {{'cues.resultados.titulo-table-3' | translate}}
              </th>
              <th class="w3-border-right-balance marginIzq stikyColum">
                {{'cues.resultados.titulo-table-4' | translate}}
              </th>
            </tr>
          </thead>
          <tbody>
            @for (row of flatTableShow; track row) {
              <tr class="w3-table-trtd">

                <td
                  class="borderAllLow alinLeft"
                  [style.padding-left.px]="(row.level+1) * 20">

                  @if(row.node.subelements?.length){

                    <mat-icon
                      class="w3-button"
                      (click)="toggleNode(row)">

                      {{ row.node.opened ? 'expand_less' : 'expand_more' }}

                    </mat-icon>

                  }

                  {{ row.node.name }}

                </td>

                <td class="borderAllLow alinCenter">
                  {{ row.node.numPreg }}
                </td>

                <td class="borderAllLow">
                  <table style="margin:auto;width:4vw;">
                    <tr>
                      <td
                        style="border-left: solid 8px;"
                        [ngStyle]="{'border-left-color': row.node.color}">
                        {{ row.node.ponder?.toFixed(1) }}
                      </td>
                    </tr>
                  </table>
                </td>

                @if(row.node.preg?.length){
                  <td class="borderAllLow alinCenter empty-cell"
                    (click)="mostrarAnswers(row.node)">
                    <span style="font-weight:bold;">
                      {{ 'cues.resultados.crear-planes' | translate }}
                    </span>
                  </td>
                }@else {
                  <td class="borderAllLow alinCenter empty-cell">
                    <span style="font-weight:bold;">
                    </span>
                  </td>
                }
                

              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
    <div class="zona2-3">
      <!-- ZONA 2  -->
      <div class="zona2">
        <div class="tarjeta">
          <div class="tarjetaFormat">
            @if (questionarySelect) {
              <app-tarjetas [header]="'cues.resultados.calificacion' | translate"
              [value]="questionarySelect.ponderacion.toFixed(1)" [footer]="''" [icon]="'verified_user'"
              [color]="iconColor"></app-tarjetas>
            }
          </div>
        </div>
        <div class="semaforos">
          <div class="contenedorSemaforos">
            <table class="w3-table" style="z-index: 1;">
              <tbody>
                @for (sem of semaforos; track sem.color; let i = $index) {
                <tr>
                  <td class="anchosL min">{{semaforosLabels[i]}} </td>
                  <td class="anchosC">
                    <div class="sem" [ngStyle]="{'background-color':sem.color}"></div>
                    <div class="w3-rest min" style="text-align:riht; font-size: 1.1em;  width: 75%;">{{sem.min + ' - ' +
                      sem.max}}</div>
                  </td>
                </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!-- ZONA 3  -->
      <div class="zona3" id="graf2">
        <div class="w3-row w3-titulo-contenidomenuSC" style="margin: 0 2%;">
          <div class="headersZonas">
            @if (encabezadoGraf1 === '') {
            <span class="textoZon">{{'cues.resultados.titulo-componente' | translate}}</span>
            }@else {
            <span class="textoZon">{{encabezadoGraf1}}</span>
            }
          </div>
          <div class="hedersIcons">
            @if (labelsG2 && (tipo == 'bar' || tipo == 'barHorizontal')) {
            <mat-icon class="w3-row w3-rigth w3-button iconoMen" [ngStyle]="{'color':'gray'}"
              (click)="etiquetas(false)">
              label_off
            </mat-icon>
            }
            @if (!labelsG2 && (tipo == 'bar' || tipo == 'barHorizontal')) {
            <mat-icon class="w3-row w3-rigth w3-button iconoMen" [ngStyle]="{'color':'gray'}" (click)="etiquetas(true)">
              label
            </mat-icon>
            }
            <mat-icon class="w3-row w3-rigth w3-button iconoMen" [ngStyle]="{'color':'gray'}" (click)="openModal(1)">
              zoom_out_map
            </mat-icon>
            <mat-icon class="w3-row w3-rigth w3-button iconoMen" [ngClass]="{'color':'grey'}"
              [matMenuTriggerFor]="menu1">
              more_vert
            </mat-icon>
            <mat-menu #menu1="matMenu">
              <button class="mat-menu-item" mat-menu-item class="w3-caja-menu"
                (click)="exportImagen('graf2','Grafica_1')">
                <mat-icon [ngStyle]="{'color':'gray'}">image</mat-icon>
                <span>{{'acciones.exportar' | translate}}</span>
              </button>
              <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" [matMenuTriggerFor]="tipoGraf1">
                <mat-icon [ngStyle]="{'color':'gray'}">assessment</mat-icon>
                <span>{{'acciones.perspectivas' | translate}}</span>
              </button>
              <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" [matMenuTriggerFor]="tipoGraf2">
                <mat-icon [ngStyle]="{'color':'gray'}">show_chart</mat-icon>
                <span>{{'acciones.graficas' | translate}}</span>
              </button>
            </mat-menu>
            <mat-menu #tipoGraf1>
              <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" [disabled]="encabezadoGraf1 === ''"
                (click)="treeMapGraf(tipo, isFunel, labelsG2)">
                <span>{{'acciones.barras' | translate}}</span>
              </button>
              <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" [matMenuTriggerFor]="elementos1">
                <span>{{'acciones.componente' | translate}}</span>
              </button>
            </mat-menu>
            <mat-menu #tipoGraf2>
              <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" [disabled]="tipo === 'bar'"
                (click)="treeMapGraf('bar', false, labelsG2)">
                <span>{{'credito.mayores.tipo3' | translate}}</span>
              </button>
              <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" [disabled]="tipo === 'radar'"
                (click)="treeMapGraf('radar', false, labelsG2)">
                <span>{{'acciones.radar' | translate}}</span>
              </button>
              <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" [disabled]="tipo === 'barHorizontal'"
                (click)="treeMapGraf('barHorizontal', false, labelsG2)">
                <span>{{'acciones.barras-horizontal' | translate}}</span>
              </button>
            </mat-menu>
            <mat-menu #elementos1>
              @if (questionarySelect) {
                @for (ele of questionarySelect.elementos; track ele.name) {
                  <button class="mat-menu-item textoOverFlow" style="max-width: 15vw !important;" mat-menu-item
                    class="w3-caja-menu" [disabled]="ele.name === encabezadoGraf1" (click)="grafBarr(ele)">
                    <div class="textoOverFlow" style="width: 15vw;">{{ele.name}}</div>
                  </button>
                }
              }
            </mat-menu>
          </div>
        </div>
        <div style="margin-top: 3%; height: 38vh;">
          <div class="zonaGraf">
            <app-graficador
              #graficador1
              [data]="data"
              [labels]="labels"
              [type]="type"
              [colors]="colores"
              [axisX]="'Calificación'"
              [axisY]="['Componentes']"
              [zona]="1"
              [etiquetas]="labelsG2"
              [distributed]="true"
              [altoEtiquetasX]="130"
              [maxLenghtRadar]="11"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div id="ampliar" class="modal" (click)="clickFuera($event)">
  <div class="modalContent" style="width: 80%;">
    <div class="w3-row" style="background-color: transparent;">
      <!--Titulo grafica modal-->
      <div class="w3-row w3-noventa2" style="background-color: transparent;">
        <div class="w3-row  w3-header-cuadrante padreizquierda"
          style="height: 6vh; margin-top: 10px; margin-left: 20px">
          <div class="w3-noventa2 w3-titulo-contenidomenu bottom hijoizquierdaTitle">
            <span class="w3-margin-left-contenido"></span>
          </div>
        </div>
      </div>
      <!--cerrar modal-->
      <div class="w3-rest w3-right w3-white" style="height: 6vh; margin-top: 10px;">
        <div class="w3-row" style="height: 3vh; transform: translate(0, 40%);">
          <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click"
            (click)="closeModal()">clear</mat-icon>
        </div>
      </div>
    </div>

    <!--area grafica-->
    <div style="padding-left: 2%; padding-bottom: 1%; padding-right: 2%;">
      <ng-container *ngIf="renderGrafAmp">
        <div class="zonaGrafAmp borderTest">
          <!-- <app-graficador
            [data]="data"
            [labels]="labels"
            [type]="type"
            [colors]="colores"
            [axisX]="'Calificación'"
            [axisY]="['Componentes']"
            [zona]="2"
            [etiquetas]="labelsG2"
            [legend]="{enabled: legends, position: 'left'}"
            [distributed]="true"
            [altoEtiquetasX]="200"
          /> -->
        </div>
      </ng-container>
      <ng-container *ngIf="renderTabAmp">
        <div class="w3-scroll" style="height: 60vh; margin-top: 2.5%;">
          <table class="w3-table">
            <thead>
              <tr class="w3-table-title">
                <th class="w3-border-right-balance marginIzq stikyColum">
                  {{'cues.resultados.titulo-table-1' | translate}}
                </th>
                <th class="w3-border-right-balance marginIzq stikyColum">
                  {{'cues.resultados.titulo-table-2' | translate}}
                </th>
              </tr>
            </thead>
            <tbody *ngFor="let el of tableShow">
              <tr class="w3-table-trtd">
                <td class="borderAllLow alinLeft">
                  <mat-icon class="w3-row w3-rigth w3-button iconoMen" *ngIf="!el.opened" [ngClass]="{'color':'grey'}"
                    (click)="el.opened = !el.opened">
                    expand_more
                  </mat-icon>
                  <mat-icon class="w3-row w3-rigth w3-button iconoMen" *ngIf="el.opened" [ngClass]="{'color':'grey'}"
                    (click)="el.opened = !el.opened">
                    expand_less
                  </mat-icon>
                  {{el.name}}
                </td>
                <td class="borderAllLow">
                  <table style="margin-left: auto; margin-right: auto; width: 4vw;">
                    <tr>
                      <td style="border-left: solid 8px;" [ngStyle]="{'border-left-color':el.color}">{{el.ponder}}
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <ng-container *ngIf="el.opened">
                <ng-container *ngFor="let el2 of el.subelements">
                  <tr class="w3-table-trtd">
                    <td class="borderAllLow alinLeft">
                      <div class="textoOverFlow" style="margin-left: 5%;" [matTooltip]="el2.name">
                        <span> {{el2.name}} </span>
                      </div>
                    </td>
                    <td class="borderAllLow">
                      <table style="margin-left: auto; margin-right: auto; width: 4vw;">
                        <tr>
                          <td style="border-left: solid 8px;" [ngStyle]="{'border-left-color':el2.color}">
                            {{el2.ponder}}</td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </ng-container>
              </ng-container>
            </tbody>
          </table>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<app-modal [isOpen]="modal" (close)="closeModal()">
  <div modal-header>
    {{titleModal}}
  </div>
  <div modal-body>
    <div class="spaceGrafica">
      @if (renderGrafAmp) {
        <div class="zonaGrafAmp">
          <app-graficador
            [data]="data"
            [labels]="labels"
            [type]="type"
            [colors]="colores"
            [axisX]="'Calificación'"
            [axisY]="['Componentes']"
            [zona]="2"
            [etiquetas]="labelsG2"
            [legend]="{enabled: legends, position: 'left'}"
            [distributed]="true"
            [altoEtiquetasX]="200"
            [sizeRadar]="200"
          />
        </div>
      }
      @if (renderTabAmp) {
        <div class="w3-scroll" style="height: 60vh; width: 100%;">
          <table class="w3-table">
            <thead>
              <tr class="w3-table-title">
                <th class="w3-border-right-balance marginIzq stikyColum">
                  {{'cues.resultados.titulo-table-1' | translate}}
                </th>
                <th class="w3-border-right-balance marginIzq stikyColum">
                  {{'cues.resultados.titulo-table-2' | translate}}
                </th>
              </tr>
            </thead>
            <tbody *ngFor="let el of tableShow">
              <tr class="w3-table-trtd">
                <td class="borderAllLow alinLeft">
                  <mat-icon class="w3-row w3-rigth w3-button iconoMen" *ngIf="!el.opened" [ngClass]="{'color':'grey'}"
                    (click)="el.opened = !el.opened">
                    expand_more
                  </mat-icon>
                  <mat-icon class="w3-row w3-rigth w3-button iconoMen" *ngIf="el.opened" [ngClass]="{'color':'grey'}"
                    (click)="el.opened = !el.opened">
                    expand_less
                  </mat-icon>
                  {{el.name}}
                </td>
                <td class="borderAllLow">
                  <table style="margin-left: auto; margin-right: auto; width: 4vw;">
                    <tr>
                      <td style="border-left: solid 8px;" [ngStyle]="{'border-left-color':el.color}">{{el.ponder}}
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <ng-container *ngIf="el.opened">
                <ng-container *ngFor="let el2 of el.subelements">
                  <tr class="w3-table-trtd">
                    <td class="borderAllLow alinLeft">
                      <div class="textoOverFlow" style="margin-left: 5%;" [matTooltip]="el2.name">
                        <span> {{el2.name}} </span>
                      </div>
                    </td>
                    <td class="borderAllLow">
                      <table style="margin-left: auto; margin-right: auto; width: 4vw;">
                        <tr>
                          <td style="border-left: solid 8px;" [ngStyle]="{'border-left-color':el2.color}">
                            {{el2.ponder}}</td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </ng-container>
              </ng-container>
            </tbody>
          </table>
        </div>
      }
    </div>
    
  </div>
</app-modal>

<div id="ampliarPreg" class="modal" (click)="clickFueraP($event)">
  <div class="modalContent " style="width: 80%;">
    <div class="w3-row">
      <!--Titulo grafica modal-->
      <div class="w3-row w3-noventa2 w3-white">
        <div class="w3-row  w3-header-cuadrante padreizquierda"
          style="height: 6vh; margin-top: 10px; margin-left: 20px">
          <div class="w3-noventa2 w3-titulo-contenidomenu bottom hijoizquierdaTitle">
            <span class="w3-margin-left-contenido">{{titleModal}}</span>
          </div>
        </div>
      </div>
      <!--cerrar modal-->
      <div class="w3-rest w3-right w3-white" style="height: 6vh; margin-top: 10px;">
        <div class="w3-row" style="height: 3vh; transform: translate(0, 40%);">
          <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click"
            (click)="closeModalP()">clear</mat-icon>
        </div>
      </div>
    </div>
    <!--area grafica-->
    <div style="width: 98%; margin-left: auto; margin-right: auto; padding-bottom: 2vh; height: 60vh !important;">
      <div class="modalPreg w3-scroll">
        <table class="w3-table">
          <thead>
            <tr class="w3-table-title">
              <th class="w3-border-right-balance marginIzq stikyColum anchosColC">
                {{'acciones.seleccione' | translate}}
              </th>
              <th class="w3-border-right-balance marginIzq stikyColum anchosCol">
                {{'cues.resultados.titulo-table-1' | translate}}
              </th>
              <th class="w3-border-right-balance marginIzq stikyColum anchosCol contenedorSort">
                <mat-icon *ngIf="sort === 'asc'" (click)="orderQuestions()" class="iconoSortIni">filter_alt</mat-icon>
                <mat-icon *ngIf="sort === 'desc'" (click)="orderQuestions()" class="iconoSort">filter_alt_off</mat-icon>
                {{'cues.resultados.titulo-table-3' | translate}}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let p of showQuestions" class="w3-table-trtd">
              <td class="borderAllLow alinCenter anchosColC">
                <mat-checkbox (change)="addOrRemoveItem(p)"></mat-checkbox>
              </td>
              <td class="borderAllLow alinLeft anchosCol">
                <div style="margin-left: 5%;" class="textoOverFlow" matTooltip="{{p.name}}">{{p.name}}</div>
              </td>
              <td class="borderAllLow alinLeft anchosCol">
                <table style="margin-left: auto; margin-right: auto; width: 4vw;">
                  <tr>
                    <td>
                      @if (p.aplica) {
                        <div style="border-left: solid 8px; padding-left: 0.5rem;" [ngStyle]="{'border-left-color':p.color}">
                          {{p.ponder.toFixed(1)}}
                        </div>
                      }@else {
                        <div style="border-left: solid 8px; padding-left: 0.5rem;" [ngStyle]="{'border-left-color':'#C8C7C8'}">
                          NA
                        </div>
                      }
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="w3-right" *ngIf="preguntasArray.length >= 1">
        <div class="botonesModales">
          <button mat-flat-button color="success" style="height: 3vh; width: 100%;" (click)="openGantt()">
            <span *ngIf="preguntasArray.length === 1">{{'acciones.create-plan' | translate}}</span>
            <span *ngIf="preguntasArray.length > 1">{{'acciones.create-plans' | translate}}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="workSpace" id="exportImages" style="position: absolute; z-index: -11000000; top: 0;">
  <div id="chart3"></div>
</div>